import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { base_url } from "../../config";
import {
  getTutorialDaysString,
  getWorkshopDaysString,
} from "../../util/ijcaihelpers";
import RegistrationContext from "../../contexts/RegistrationContext";


const Layout = ({ children, onClose }) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
    <div
      className="bg-white relative flex flex-col"
      style={{
        width: "80vw",
        maxWidth: "900px",
        height: "80vh",
        borderRadius: "12px",
        boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
        overflow: "auto",
      }}
    >
      <button
        className="absolute top-4 right-4 text-2xl font-bold text-gray-700"
        onClick={onClose}
      >
        &times;
      </button>

      {children}
    </div>
  </div>
);
const Loading = ({ onClose }) => (
  <Layout onClose={onClose}>
    <div className="flex items-center justify-center h-full">
      <div className="animate-spin rounded-full h-12 w-12 border-b-4 border-gray-900"></div>
    </div>
  </Layout>
);

const RegistrationDetail = ({ open, loading, data, onClose }) => {
  const [stdata, setStData] = useState(data);
  const [basic, setBasic] = useState({});
  const [extra, setExtra] = useState({});
  const [user, setUser] = useState({});
  const [enterPaper, setEnterPaper] = useState(false);
  const [loadingEnabledButton, setLoadingEnabledButton] = useState(false);
  const [paperId, setPaperId] = useState(null);
  const [, setAppliyingPaper] = useState(false);
  const { permissions } = useContext(RegistrationContext);

  useEffect(() => {
    if (stdata && stdata.data) {
      setBasic(stdata.data);
      setExtra(stdata.data.extra_registration_i_j_c_a_i25 || {});
      setUser(stdata.data.user || {});
    }
  }, [stdata]);

  useEffect(() => {
    setStData(data);
  }, [data]);
  if (!open) return null;
  if (loading) return <Loading onClose={onClose} />;
  const enableUpdates = async (id, value) => {
    setLoadingEnabledButton(true);
    try {
      const response = await axios.post(
        `${base_url}/api/admin/enable_updates`,
        {
          id: id,
          value: value,
        }
      );
      setStData(response.data);
    } catch (error) {
      console.error("Error enabling updates:", error);
    } finally {
      setLoadingEnabledButton(false);
    }
  };

  const handleSetPaperId = async () => {
    setAppliyingPaper(true);
    try {
      const response = await axios.post(`${base_url}/api/admin/add_paper`, {
        registration_id: basic.id,
        paper_id: paperId,
      });
      setStData(response.data);
    } catch (error) {
      console.error("Error enabling updates:", error);
    } finally {
      setAppliyingPaper(false);
      setEnterPaper(false);
    }
  };


   
  const is_complete = basic.max_step === "Confirmation";
  //const in_progress = basic.max_step !== "Confirmation";
  return (
    <Layout onClose={onClose}>
      <div className="p-6 flex flex-col h-full  ">
        <h2 className="text-2xl font-bold mb-4">Registration Details</h2>
        <div className="overflow-y-scroll">
          <p className="text-gray-700 mb-4">
            Here you can view the details of the registration.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4 ">
            <div className="bg-gray-100 p-4 rounded-lg shadow">
              <h3 className="text-lg font-semibold mb-2">
                Personal Information
              </h3>
              <p className="text-gray-600">
                Name:{" "}
                <b>
                  {extra.first_name} {extra.family_name}
                </b>
              </p>
              <p className="text-gray-600">
                Affiliation: <b>{extra.affiliation}</b>
              </p>
              {extra.affilition2 && (
                <p className="text-gray-600">
                  Affiliation 2: <b>{extra.affilition2}</b>
                </p>
              )}
              <p className="text-gray-600">
                Email: <b>{user.email}</b>{" "}
              </p>
              
              <div className = "mt-4">
                
              </div>
            </div>
            <div className="bg-gray-100 p-4 rounded-lg shadow">
              <h3 className="text-lg font-semibold mb-2">
                Registration Details
              </h3>
              <div className="flex justify-between">
                <div className="text-gray-600">
                  Registration ID: <b> {basic.registration_id}</b>
                </div>
                <div>#{basic.id}</div>
              </div>
              <p className="text-gray-600">
                Status:{" "}
                <b>
                  {basic.max_step === "Confirmation"
                    ? "Complete"
                    : "In progress"}
                </b>
              </p>
              <p className="text-gray-600">
                Registration Type:
                <b>
                  {extra.type === "student-paper" && " Student with Paper"}
                  {extra.type === "student" && " Student"}
                  {extra.type === "regular" && " Regular delegate"}
                  {extra.type === "industry" && " Industry day"}
                  {extra.type === "exhibitor" && " Exhibitor"}
                </b>
              </p>
              <p className="text-gray-600">
                Tutorial days:<b> {getTutorialDaysString(extra)}</b>
              </p>
              <p className="text-gray-600">
                Workshops days: <b>{getWorkshopDaysString(extra)}</b>
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4 ">
            <div className="bg-gray-100 p-4 rounded-lg shadow">
              <h3 className="text-lg font-semibold mb-2">Papers registered</h3>
              {basic.papers && basic.papers.length > 0 ? (
                <div>
                  {basic.papers
                    .map(
                      (paper) =>
                        `[${paper.paper_id} - ${
                          paper.pivot.presented_at || "missing-location"
                        }]`
                    )
                    .join(", ")}
                </div>
              ) : (
                <p className="text-gray-600">No papers selected.</p>
              )}
              <h3 className="text-lg font-semibold mt-4 mb-2">
                Workshop selection
              </h3>
              {extra.workshops && extra.workshops.length > 0 ? (
                <div>
                  {extra.workshops
                    .map((workshop) => workshop.workshop_code)
                    .join(", ")}
                </div>
              ) : (
                <p className="text-gray-600">No workshops selected.</p>
              )}
              <h3 className="text-lg font-semibold mt-4 mb-2">
                Tutorial selection
              </h3>
              {extra.tutorials && extra.tutorials.length > 0 ? (
                <div>
                  {extra.tutorials
                    .map((tutorial) => tutorial.tutorial_code)
                    .join(", ")}
                </div>
              ) : (
                <p className="text-gray-600">No tutorials selected.</p>
              )}
            </div>
            <div className="bg-gray-100 p-4 rounded-lg shadow">
              <h3 className="text-lg font-semibold mb-2">Social Events</h3>

              <div className="flex justify-between">
                <div className="text-gray-600">
                  Reception (
                  {
                    extra.social_event_preferences.filter(
                      (i) => i.event === "reception"
                    ).length
                  }
                  ):{" "}
                  <b>
                    {extra.social_event_preferences
                      .filter((i) => i.event === "reception")
                      .map((i) => i.choice)
                      .join(", ")}{" "}
                  </b>
                </div>
              </div>
              <div className="flex justify-between">
                <div className="text-gray-600">
                  Student Reception (
                  {
                    extra.social_event_preferences.filter(
                      (i) => i.event === "student_reception"
                    ).length
                  }
                  ):{" "}
                  <b>
                    {extra.social_event_preferences
                      .filter((i) => i.event === "student_reception")
                      .map((i) => i.choice)
                      .join(", ")}{" "}
                  </b>
                </div>
              </div>
              <div className="flex justify-between">
                <div className="text-gray-600">
                  Banquet (
                  {
                    extra.social_event_preferences.filter(
                      (i) => i.event === "gala_dinner"
                    ).length
                  }
                  ):{" "}
                  <b>
                    {extra.social_event_preferences
                      .filter((i) => i.event === "gala_dinner")
                      .map((i) => i.choice)
                      .join(", ")}{" "}
                  </b>
                </div>
              </div>
              <div className="flex justify-between">
                <div className="text-gray-600">
                  {extra.diversity_and_inclusion > 0 ? (
                    <div>
                      Diversity and inclusion:{" "}
                      <b>{extra.diversity_and_inclusion}</b>
                    </div>
                  ) : (
                    <div>
                      Diversity and inclusion: <b>No </b>
                    </div>
                  )}
                </div>
              </div>

            </div>
          </div>

          <div
            style={{
              flex: "1 1 0",
              paddingTop: "20px" /*overflowY: "scroll" */,
            }}
            className="mt-4"
          >
            {/* <div className="flex text-xs">
            <div>
              <pre>{JSON.stringify({ data }, null, 2)};</pre>
            </div>
          </div>  */}
          </div>
        </div>

        <div className="mt-4 flex  space-x-2">
          {is_complete && loadingEnabledButton && (
            <button disabled>
              <span
                className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 flex 
                        items-center justify-center opacity-50 cursor-not-allowed"
              >
                <span className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></span>
                Processing
              </span>
            </button>
          )}

         

          {is_complete &&
            !loadingEnabledButton &&
            extra.update_enabled === 0 && (
              <button onClick={() => enableUpdates(basic.id, 1)}>
                <span className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center justify-center">
                  Enable updates{" "}
                </span>
              </button>
            )}
          {is_complete &&
            !loadingEnabledButton &&
            extra.update_enabled !== 0 && (
              <button onClick={() => enableUpdates(basic.id, 0)}>
                <span className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center justify-center">
                  Disable updates{" "}
                </span>
              </button>
            )}

          {is_complete && permissions.includes("ijcai_add_paper") && (
            <>
              {enterPaper ? (
                <div>
                  <input
                    style={{ width: "90px", marginRight: "10px" }}
                    className="border border-gray-300 rounded px-2 py-1"
                    placeholder="Paper ID"
                    onChange={(e) => setPaperId(e.target.value)}
                  ></input>
                  <button
                    style={{ width: "60px" }}
                    onClick={() => handleSetPaperId()}
                  >
                    <span className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center justify-center">
                      ok
                    </span>
                  </button>
                </div>
              ) : (
                <button
                  style={{ width: "160px" }}
                  onClick={() => setEnterPaper(true)}
                >
                  <span className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center justify-center">
                    Add Paper{" "}
                  </span>
                </button>
              )}
            </>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default RegistrationDetail;
